<template>
  <div class="gallery">
    <FilteredGallery />
  </div>
</template>

<script>
import FilteredGallery from './components/FilteredGallery.vue';

export default {
  name: 'GalleryView',
  components: {
    FilteredGallery
  }
}
</script>

<style scoped>
.gallery {
  padding: 0.5rem;
  max-width: 1200px;
  margin: auto;
}
</style>
